/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do my feet-to-meters conversions sometimes look rounded differently elsewhere?`)
};

const es_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mis conversiones de pies a metros a veces se ven redondeadas de manera diferente en otros lugares?`)
};

const de_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum sehen meine Fuß-zu-Meter-Umrechnungen anderswo manchmal anders gerundet aus?`)
};

const nl_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom zien mijn voet-naar-meter conversies er soms afgerond anders uit?`)
};

const fr_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi mes conversions pieds-en-mètres semblent-elles parfois arrondies différemment ailleurs ?`)
};

const it_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché le mie conversioni da piedi a metri a volte sembrerebbero arrotondate diversamente altrove?`)
};

const pt_br2_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que minhas conversões de pés para metros às vezes parecem arredondadas diferentemente em outros lugares?`)
};

const pt_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que as minhas conversões de pés-para-metros às vezes parecem arredondadas de forma diferente noutro lado?`)
};

const ja_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィートからメートルへの変換が他の場所では丸められる方法が異なるのはなぜですか?`)
};

const zh_uc_len_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_len_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_len_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_len_faq4_q", locale)
	if (locale === "en") return en_uc_len_faq4_q(inputs)
	if (locale === "es") return es_uc_len_faq4_q(inputs)
	if (locale === "de") return de_uc_len_faq4_q(inputs)
	if (locale === "nl") return nl_uc_len_faq4_q(inputs)
	if (locale === "fr") return fr_uc_len_faq4_q(inputs)
	if (locale === "it") return it_uc_len_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_len_faq4_q(inputs)
	if (locale === "pt") return pt_uc_len_faq4_q(inputs)
	if (locale === "ja") return ja_uc_len_faq4_q(inputs)
	return zh_uc_len_faq4_q(inputs)
};